import React, { Component } from 'react';

import AddComment from './components/add-comment';
import { Button } from 'reactstrap';
import { withNamespaces } from 'react-i18next';
import { Card, CardBody, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Services } from './../../../Services'
import { Menu, Dropdown } from 'antd';
import { MoreOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import Table from "../../../../Components/Table";
import './styles.scss';

import { FilterForRole } from '../../../../../Global/Permission/filter';
import { moduleActions } from '../../../../../Global/Permission/constants';
import Axios from 'axios';
import createModal from '../../../../Components/ModalV2';

const size = '18px';
class Tracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      openDeleteModal: false,
      comments: [],
      order: {},
      data: [],
      columns: [
        {
          label: this.props.t("actions"), key: '', custom: (value) => {
            return <Dropdown overlay={
              (
                <Menu>
                  <Menu.Item >
                    <div style={{ display: "inline-flex", alignItems: "center" }} className='container-options' >
                      <CloudDownloadOutlined style={{ fontSize: size }} />
                      <a style={{ color: "#000a2e", textDecoration: 'none', fontWeight: '100' }} href={value.URL}>
                        <i style={{ marginLeft: "10px" }} className='global-text'><span className=" global-text" style={{ fontSize: '14px', fontStyle: 'italic' }}>{this.props.t("download")}</span></i>
                      </a>
                    </div>
                  </Menu.Item>
                  {!this.props.isMobil && ![".docx"].includes(value.Type) ?
                    <Menu.Item onClick={() => {
                      // window.open('https://apiposeidon.azurewebsites.net/order/document/view/pdf/?url=' + value.URL);
                      window.open(`${Services.ORDEN_SERV.path}orderDocument/document/view/pdf/?url=${value.URL}`);
                    }}>
                      <div style={{ display: "inline-flex", alignItems: "center", marginLeft: '-15px' }} className='container-options' >
                        <i style={{ marginLeft: "10px", fontSize: '19px', marginLeft: '12px' }} className=" global-text icon-search"   ><span className=" global-text" style={{ fontSize: '14px', fontStyle: 'italic', marginLeft: '4px' }}>{this.props.t("open")}</span></i>
                      </div>
                    </Menu.Item>
                    :
                    false
                  }
                  {
                    // (value.CreateBy === 'API' && this.props.rolId === '1') || (value.CreateBy === 'API' && this.props.rolId === '6') ?
                    <FilterForRole rol={this.props._rolId} userId={this.props._user}
                      moduleAction={moduleActions.PEDIDO_ELIMINAR_DOCUMENTO}
                      userCreatedId={value.UserId}>
                      <Menu.Item onClick={() => this.rmDocument(value)}>
                        <div style={{ display: "inline-flex", alignItems: "center", marginLeft: '-4px' }} className='container-options' >
                          <span style={{ fontSize: '18px' }} disabled={props.disabled} className="icon-delete global-text" >  <span className=" global-text" style={{ fontSize: '14px', fontStyle: 'italic' }}>{this.props.t("eliminate")}</span></span>
                        </div>
                      </Menu.Item>
                    </FilterForRole>
                    // : ''
                  }
                </Menu>
              )
            } placement="topCenter">
              <div >
                <MoreOutlined className='btn-expander' style={{ fontSize: '26px' }} />
              </div>
            </Dropdown>

          }
        },
        { label: this.props.t("document_name"), key: 'Name' },
        { label: this.props.t("document_category"), key: 'Description' },
        { label: this.props.t("created_on"), key: 'CreationDateDocument' },
        // { label: 'Download', key: '', custom: (value) => {
        //   return (
        //     <a className="fas fa-download fa-2x " href={value.URL}></a>
        //   );
        // }
        // },
        // {
        //   label: 'View', key: '', custom: (value) => {
        //     return (
        //       <a className="fas fa-search fa-2x " onClick={() => window.open('https://apiposeidon.azurewebsites.net/order/document/view/pdf/?url=' + value.URL)}></a>
        //     );
        //   }
        // },
        // { label: '', key: '', custom: (value) => this.delDoc(value) },
      ],
    };
  }

  componentDidMount = () => {
    this.setState({
      order: this.props.order,
      id: this.props.id,
      data: this.props.data,
    }, () => {
      this.getComments();
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      data: nextProps.data,
      id: nextProps.id
    }, () => this.getComments());
  }

  delDoc = (value) => (value.CreateBy === 'API' && this.props.rolId === '1') || (value.CreateBy === 'API' && this.props.rolId === '6') ? <a className="fas fa-trash-alt fa-2x" onClick={() => this.rmDocument(value)}></a> : <></>

  getComments = async () => {
    let { id } = this.state;
    let url = `${Services.ORDEN_SERV.path}orderDocument/search/${id}?userId=${this.props._user}&moduleId=${2}`;

    let success = await Axios.get(url);
    if (success.data && success.data.data) {
      this.setState({
        data: success.data.data,
      });
    }
  }

  toggle = evt => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  callback = (success) => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => this.getComments());
  }

  onError = (error) => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => this.getComments());
  }

  rmDocument = (value) => {
    this.setState({ openDeleteModal: true, modalValue: value, nameDoc: value.Name });
  }

  toggleDeleteModal = evt => {
    this.setState(prevState => ({
      openDeleteModal: !prevState.openDeleteModal
    }));
  }

  removeDocumentModal = async () => {
    let values = this.state.modalValue;
    let url = `${Services.ORDEN_SERV.path}orderDocument/delete/`;

    await Axios.post(url, values)
      .then(success => {
        if (success.data.code === 200) {
          this.setState({ openDeleteModal: false }, () => this.getComments());
        } else {
          console.error('No se pudo eliminar el documento');
        }
      });

  }

  render() {
    let { modal, openDeleteModal } = this.state

    return (
      <>
        <Card className="myCard">
          <CardBody>
            <div className="row">
              <div className="col-12">
                <Table
                  columns={this.state.columns}
                  data={this.state.data}
                  itemsByPage={10}
                  options={{
                    large: false,
                    downloads: {
                      pdf: false,
                      xlsx: false
                    },
                    pagination: true,
                    search: false
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-11">
              </div>
              <div className="col-1">
                <Button
                  color="primary"
                  onClick={this.toggle}
                >
                  <span className="icon-plus icon-button-add no-margin" />
                </Button>
              </div>
            </div>
          </CardBody>
        </Card>
        {/* <Modal isOpen={this.state.modal} toggle={this.toggle} >
          <ModalHeader toggle={this.toggle}>{this.props.t("create_new_document")}</ModalHeader>
          <ModalBody>
            <AddComment callback={this.callback} onError={this.onError} id={this.state.id} _user={this.props._user} />
          </ModalBody>
        </Modal> */}

        {/* 
        <Modal isOpen={this.state.openDeleteModal} toggle={this.toggleDeleteModal}>
          <ModalHeader id={'delete_document'} className="header Modal Remove Document" toggle={this.toggleDeleteModal}><span className='euro-title-form'>{this.props.t("delete_document")}</span></ModalHeader>
          <ModalBody>
            <center>{this.props.t("are_sure_delete_document", { docname: this.state.nameDoc })}</center>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" className="custom-width-btn" onClick={this.removeDocumentModal}>{this.props.t("yes")}</Button>{' '}
            <Button color="secondary" className="custom-width-btn" onClick={this.toggleDeleteModal}>{this.props.t("cancel")}</Button>
          </ModalFooter>
        </Modal> */}

        {createModal({
          isModalOpen: modal,
          titleModal: this.props.t("create_new_document"),
          component: <AddComment callback={this.callback} onError={this.onError} id={this.state.id} _user={this.props._user} onCancel={this.toggle} />,
          onCancel: this.toggle,
          width: '500px',
          destroyOnClose: true
        })}

        {createModal({
          isModalOpen: openDeleteModal,
          titleModal: this.props.t("delete_document"),
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t("are_sure_delete_document", { docname: this.state.nameDoc })}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("cancel"),
              onClick: this.toggleDeleteModal,
              type: "secondary",
            },
            {
              text: this.props.t("yes"),
              onClick: this.removeDocumentModal,
              type: "primary",
            },
          ],
          onCancel: this.toggleDeleteModal
        })}
      </>
    );
  }
}

export default withNamespaces()(Tracking);